import React from "react";
import { useHistory, useNavigate } from "react-router-dom";
import { ICON_ARROW_LEFT } from "../utils/icons";

const BackButton = () => {
    const navigate = useNavigate();

    function gooBack() {
        navigate(-1);
    }
    return (
        <>
            <a className="d-flex align-items-center light-text pry fit-content br-lg px-2 pointer mb-3 mb-sm-2" onClick={gooBack}>
                <p className=" mr-2 m-0">
                    {ICON_ARROW_LEFT}
                </p>
                <p className='mr-2 m-0 mt-1'>
                    Back </p>
            </a>
        </>
    );
};

export default BackButton;
